import React from "react";
import StarPurple500OutlinedIcon from "@mui/icons-material/StarPurple500Outlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import ProductsData from "../data/ProductsData";
import ProductCard from "./ProductCard";

export default function ProductList() {
  return (
    <div className="category_outer_main">
      <div className="container-fluid">
        <div className="row g-2">
          {ProductsData.map((item) => (
          <div className="col-lg-3 col-md-3 col-sm-6 col-6">
              <div key={item.id}>
                <ProductCard product={item} />
              </div>
          </div>
          ))}
        </div>
      </div>
    </div>
  );
}
